import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '..';

import './index.css';

class SolidButton extends Component {
  constructor(props) {
    super(props);

    this.getClassNames = this.getClassNames.bind(this);
  }

  getClassNames() {
    const { className } = this.props;
    return classnames({
      Solid: true,
      [className]: true,
    });
  }

  render() {
    const { getClassNames } = this;
    return <Button {...this.props} className={getClassNames()} />;
  }
}

SolidButton.propTypes = {
  className: PropTypes.string,
};

SolidButton.defaultProps = {
  className: '',
};

export default SolidButton;
